import React, { useEffect, useState } from 'react';
import Box from '@mui/material/Box';
import { Container, Grid, IconButton, ImageList, ImageListItem, ImageListItemBar, Link, Typography } from '@mui/material';

import { useNavigate } from 'react-router-dom';
import './Landing.css';
import Header from './header';
import { fetchProperties, formatNumber, getPhotoUrl, PropertyData } from './properties';


export default function Landing() {


    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');
    const [properties, setProperties] = useState<PropertyData[]>([]);

    const navigate = useNavigate();

    const navigateTo = (url: string) => {
        return (event: React.MouseEvent) => {
            navigate(url);
            event.preventDefault();
        }
    }

    useEffect(() => {
        fetchProperties()
            .then(setProperties)
            .catch((err) => setError(err instanceof Error ? err.message : 'No se pudieron cargar las propiedades'))
            .finally(() => setLoading(false));
    }, []);

    const newitemData = [...properties].sort((a, b) => {
        const orderA = a.order ?? -Number(a.id);
        const orderB = b.order ?? -Number(b.id);
        return orderA - orderB;
    });

    if (loading) {
        return (<Typography sx={{ p: 4 }}>Cargando propiedades...</Typography>)
    }

    if (error) {
        return (<Typography sx={{ p: 4 }}>{error}</Typography>)
    }
    else {
        return (


            <Box sx={{ width: "100%" }}>
                <Header></Header>
                <Container>

                    <Grid container spacing={20} sx={{ padding: 2 }} >
                        <Grid item xs={12} >  </Grid>
                        <Grid item xs={12}>
                            <ImageList sx={{
                                mb: 8,
                                gridTemplateColumns:
                                    'repeat(auto-fill, minmax(280px, 1fr))!important',
                            }} >
                                {newitemData.map((item) => (
                                    <ImageListItem key={item.fotos[0].img}>


                                        <img
                                            srcSet={getPhotoUrl(item.fotos[0])}
                                            src={getPhotoUrl(item.fotos[0])}
                                            alt={item.titulo}
                                            loading="lazy"
                                            style={{ cursor: 'pointer' }}
                                            onClick={navigateTo('./Property/' + item.id)}
                                        />

                                        <ImageListItemBar
                                            title={item.comuna + " " + formatNumber(item.precio) + "UF"}
                                            subtitle={formatNumber(item.m2_totales) + " MT2"}
                                            position="below"
                                            sx={{
                                                "& .MuiImageListItemBar-title": { color: "black" }, //styles for title
                                                "& .MuiImageListItemBar-subtitle": { color: "black" }, //styles for subtitle
                                            }}

                                            actionIcon={
                                                <Link href={'./Property/' + item.id}>
                                                    <IconButton
                                                        sx={{ color: 'rgba(255, 255, 255, 0.54)' }}
                                                        aria-label={`info about ${item.precio} ${item.comuna}`}
                                                    >
                                                    </IconButton>
                                                </Link>
                                            }
                                        />



                                    </ImageListItem>

                                ))}
                            </ImageList>
                        </Grid>
                    </Grid>
                </Container>
            </Box>
        )
    }
}

